// extracted by mini-css-extract-plugin
module.exports = {"rotation":"MagazineHubTemplate_rotation__ugDgj"};